import React,{useCallback,useState} from 'react';
import Dropzone,{useDropzone} from 'react-dropzone';
import { Util, toByteSize, RequestConfig } from '../common';
import _Select from '@material-ui/core/Select';
import { View } from './Base';
import { Input as _Input } from './input/Base';
import { FormControl, InputLabel, FormHelperText, LinearProgress } from '@material-ui/core';
import { Upload as _Upload,twoDecimal,Request } from '../common';
import request from 'superagent';


function getMime(e){
    switch(e){
        case "bmp":case ".bmp":return "image/bmp";
        case "doc":case ".doc":return "application/msword";
        case "docx":case ".docx": return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        case "gif":case ".gif":return "image/gif";
        case "htm":
        case ".htm":
        case "html":
        case ".html": return "text/html";
        case "jpg":
        case ".jpg":
        case "jpeg":
        case ".jpeg": return "image/jpeg";
        case "png":
        case ".png": return "image/png";
        case "pdf":
        case ".pdf": return "application/pdf";
        case "ppt":
        case ".ppt": return "application/vnd.ms-powerpoint";
        case "pptx":
        case ".pptx": return "application/vnd.openxmlformats-officedocument.presentationml.presentation";
        case "rar":
        case ".rar": return "application/x-rar-compressed";
        case "txt":
        case ".txt": return "text/plain";
        case "xls":
        case ".xls": return "application/vnd.ms-excel";
        case "xlsx":
        case ".xlsx": return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        case "zip":
        case ".zip": return "application/zip";
        case "7z":
        case ".7z": return "application/x-7z-compressed";
    }
}

function mapMime(accept){
    return accept;
    // let l = accept.split(',');
    // if(!l || l.length==0) return null;
    // l = Util.select(l,(t)=> getMime(t));
    // l= Util.where(l,(t)=>t);
    // return l.join(',');
}

class Accept extends React.Component  {
    constructor(props) {
        super(props);
        this.state={
            acceptedFiles:[],
            rejectedFiles:[],
            percents:{},
            status:"i"
        }
        this.files=[];
        this.result=[];
        this.req=null;
    }

    useDirectory({directoryId,getDirectory,callback}){
        if(directoryId) callback(directoryId);
        else{
            //实时获得目录编号
            let my = this;
            Request({
                url: getDirectory,
                success: (r) => {
                  var dirId = r.Id;
                  callback(dirId);
                }
              });
        }
    }

    upload(directoryId){
        if(this.files.length ==0) return false;
        let {onUploaded}=this.props;
        let {percents} =this.state;
        let my=this;
        var file = this.files.shift();
        file.id="file_"+Util.getId();
        _Upload({
            before:()=>{},
            complete:()=>{},
            data: {file,directoryId},
            progress:(e)=>{
                percents[file.id]=e.percent;
                my.setState(percents);
                /* the event is:
                {
                    direction: "upload" or "download"
                    percent: 0 to 100 // may be missing if file size is unknown
                    total: // total file size, may be missing
                    loaded: // bytes downloaded or uploaded so far
                } */
            },
            success: (r) => {
                my.result.push(r);
                if(my.files.length > 0)
                    my.upload(directoryId); //继续上传
                else{
                    var items = Util.select(my.result,(item)=>{ return {...item}; });
                    my.result=[];
                    my.setState({status:"c"},()=>{
                        onUploaded(items);
                    });
                }
            }
        });
    }

    cancel(){
        Request.abort();
    }

    drop(files){ //以程序的方式拖动文件对象到组件，自动上传
        this.onDrop(files);
    }

    onDrop(acceptedFiles){
        this.setState({status:"g",acceptedFiles});
        this.files = acceptedFiles.slice();
        let {directoryId,getDirectory}=this.props;
        let my = this;

        this.useDirectory({
            directoryId,
            getDirectory,
            callback:(dirId)=>{
                my.upload(dirId);
            }
        });
    }

    onDropRejected(rejectedFiles){
        this.setState({rejectedFiles});
    }
    
    renderRejectedFiles(){
        let {rejectedFiles}=this.state;
        let {maxSize,accept}=this.props;
        return rejectedFiles.length>0?[
            <h3 key={0}>被拒绝的文件<font style={{fontSize:"0.8rem",color:"#f44336"}}>（文件大小不要超过{maxSize}M，仅接受 {accept} 类型的文件）</font></h3>,
            <ul className="c-rejected" key={1}>
            {rejectedFiles.map(file => (
                <li key={file.path}>
                    {file.path} - {toByteSize(file.size)}
                </li>
            ))}
            </ul>
        ]:null;
    }
    
    renderAcceptedFiles(){
        let {acceptedFiles,percents,status}=this.state;
        if(acceptedFiles.length ==0) return;
        return [
          <h3 key={0} className="mt-2">{status=="g"?"正在上传文件":"上传完毕"}</h3>,
          <ul className="c-uploading" key={1}>
          {
              acceptedFiles.map((file,i) => {
                let percent = percents[file.id] || 0;
                return <li key={i}>
                    <View>
                        <View style={{flexDirection:"row",justifyContent:"space-between",alignItems:"center"}}>
                            <p className="c-upload-text">{twoDecimal(percent)+"%"}</p>
                            <p className="c-upload-text"> {toByteSize(percent/100*file.size)} / {toByteSize(file.size)}</p>
                        </View>
                        <View>
                            <LinearProgress color="primary" className={percent==100?"c-upload-progress-success":""} variant="determinate" value={percent}/>
                        </View>
                        <View>
                            <p className="c-upload-text">{file.path}</p>
                        </View>
                    </View>
                </li>})
            }
            </ul>
      ];
    }
     
    render() {
        let {accept,multiple,maxSize}=this.props;
        let {acceptedFiles,rejectedFiles,status}=this.state;
        return (
            <Dropzone accept={mapMime(accept)} onDrop={(files)=>{ this.onDrop(files);}} multiple={multiple} maxSize={maxSize*1024*1024} onDropRejected={(files)=>{ this.onDropRejected(files);}} > 
            {({getRootProps, getInputProps}) => (
            <div className="dropzone-card">
                {
                    status=="i"?<div className="dropzone">
                    <div {...getRootProps({className: 'dropzone-file-btn'})}>
                      <input {...getInputProps()} />
                      <p>将文件拖放到此处，或单击以选择文件</p>
                      {
                          accept?<em>(仅接受 {accept} 类型的文件)</em>:null
                      }
                    </div>
                  </div>:null
                }
                {
                  acceptedFiles.length>0||rejectedFiles.length>0?
                  <div className="dropzone-content">
                        {this.renderAcceptedFiles()}
                        {this.renderRejectedFiles()}
                    </div>
                  :null
                }
            </div>
            )}
            </Dropzone>
          );
    }
}


export default class Upload extends _Input {
   
    constructor(props) {
        super(props);
        this.state={
            ...this.state
        }
    }


    cancel(){
        this.accept.cancel();
    }

    drop(files){
        this.accept.drop(files);
    }


    render() {
        let {label,help,directoryId,getDirectory,onUploaded,accept,multiple,maxSize} = this.props;
        let {error}=this.state;
        return (
            <FormControl className="w-100 c-input c-upload" >
                {this.tipComponent("upload",{fixed:true})}
                <Accept ref={(r)=>{ this.accept=r; }} directoryId={directoryId} getDirectory={getDirectory} onUploaded={onUploaded} accept={accept} multiple={multiple} maxSize={maxSize} />
                {error||help?<FormHelperText>{error||help}</FormHelperText>:null} 
            </FormControl>
        )
    }
  }
  
  Upload.defaultProps = {

  }
  
